/* eslint-disable max-len */
import React from 'react';
import { Dialog } from 'ui-components/dialog';
import { Button } from 'ui-components/button/button';
import { ReportIsReadyIcon } from 'components/assets/Icons/ReportIsReadyIcon';
import { MODAL_WIDTH } from 'ui-components/share-report-modal/share-report-modal';
import styles from './share-confirmation-modal.module.scss';

type ShareConfirmationModalProps = {
    visible: boolean;
    onCloseModal: () => void;
};

export const ShareConfirmationModal = ({ visible, onCloseModal }: ShareConfirmationModalProps) => {
    const onCancelClick = () => {
        onCloseModal();
    };

    return (
        <Dialog
            centered
            destroyOnClose
            closable={false}
            className={styles.wrapper}
            visible={visible}
            footer={false}
            onCancel={onCancelClick}
            width={MODAL_WIDTH}

        >
            <div className={styles.content}>
                <ReportIsReadyIcon className={styles.icon} />
                <span className={styles.title}>Sent!</span>
                <span className={styles.description}>Your report has been successfully shared.</span>
                <Button
                    className={styles.closeButton}
                    type="brand-primary-full"
                    onClick={onCancelClick}
                >
                    Close
                </Button>
            </div>
        </Dialog>
    );
};
